document.querySelectorAll('.keyvisual-slider').forEach((slider) => {
  new KeyvisualSlider(slider);
});

function KeyvisualSlider(id) {
  var slider = id,
    slides,
    bullets,
    slidesCount,
    currentSlide,
    touchstartX = 0,
    touchendX = 0,
    self = this;
  this.init = function () {
    slides = slider.getElementsByClassName('keyvisual-slide');
    slidesCount = slides.length;
    bullets = slider.querySelectorAll('.keyvisual-slide-selection-bullets [data-target]');
    if (slidesCount > 1) {
      slider.addEventListener('touchstart', function (event) {
        touchstartX = event.changedTouches[0].screenX;
      });
      slider.addEventListener('touchend', function (event) {
        touchendX = event.changedTouches[0].screenX;
        self.handleSwipe();
      });
    }
    bullets.forEach(function (button) {
      button.addEventListener('click', function () {
        self.select(document.getElementById(button.dataset.target));
      });
    });
    slider.querySelectorAll('.keyvisual-slide-selection-arrows [data-direction]').forEach(function (button) {
      button.addEventListener('click', function () {
        self.change(button.dataset.direction, true);
      });
    });
    self.updateInert();
    self.updateActiveBullet();
  };
  this.select = function (input) {
    input.checked = true;
    self.updateInert();
    self.updateActiveBullet();
  };
  this.updateInert = function () {
    var activeIndex = parseInt(slider.querySelector('input:checked').dataset.slide) - 1;
    Array.prototype.forEach.call(slides, function (slide, index) {
      slide.toggleAttribute('inert', index !== activeIndex);
    });
  };
  this.updateActiveBullet = function () {
    var activeId = slider.querySelector('input:checked').id;
    bullets.forEach(function (button) {
      if (button.dataset.target === activeId) {
        button.setAttribute('aria-current', 'true');
      } else {
        button.removeAttribute('aria-current');
      }
    });
  };
  this.handleSwipe = function () {
    if (touchendX < touchstartX) self.change('next'); // swiped left
    if (touchendX > touchstartX) self.change('prev'); // swiped right
  };
  this.change = function (direction, wrap) {
    currentSlide = parseInt(slider.querySelector('input:checked').dataset.slide);
    if (direction == 'next') {
      currentSlide = wrap ? (currentSlide == slidesCount ? 1 : currentSlide + 1) : currentSlide + (currentSlide < slidesCount ? 1 : 0);
    } else {
      currentSlide = wrap ? (currentSlide == 1 ? slidesCount : currentSlide - 1) : currentSlide - (currentSlide > 1 ? 1 : 0);
    }
    self.select(document.getElementById('keyvisual-slide-' + currentSlide));
  };
  this.init();
}
